import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ReactStars from 'react-rating-stars-component';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import useModalStyles from '../../../common/components/Modal/styles/modal';
import { useTranslation } from 'react-i18next';

const HowWasLessonModal = ({
  open,
  onClose,
  onRatingChange,
  tutorImage,
  onContinue,
}) => {
  const classes = useModalStyles();
  const { t } = useTranslation('page/student_lessons_list');

  return (
    <Modal open={open}>
      <div className={classes.modalLessonWrap}>
        <div className={classes.modalLessonHeaderWrap}>
          <CloseIcon
            className={classes.modalLessonCloseIcon}
            onClick={onClose}
          />
        </div>

        <div className={classes.modalLessonBodyWrap}>
          <img src={tutorImage} className={classes.modalLessonTutorImg} />
        </div>

        <h2 id="simple-modal-title" className={classes.modalLessonTitle}>
          {t('tutor_lesson_table_component.how_was_your_lesson')}
        </h2>

        <p id="simple-modal-description" className={classes.title}>
          {t('tutor_lesson_table_component.rating_is_anonymous')}
        </p>

        <div className={classes.modalLessonStarts}>
          <ReactStars
            count={5}
            size={52}
            activeColor="#ffd700"
            isHalf={true}
            onChange={onRatingChange}
          />
        </div>

        <div className={classes.modalLessonBtnWrap}>
          <Button
            variant="contained"
            className={classes.modelLessonBtnContinue}
            onClick={onContinue}
          >
            {t('tutor_lesson_table_component.continue')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default HowWasLessonModal;
